"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.setLocalStorage = exports.getLocalStorage = void 0;

var ASSETS_CACHE = "assetsUploads",
    getLocalStorage = function getLocalStorage() {
  return JSON.parse(localStorage.getItem(ASSETS_CACHE) || "{}");
};

exports.getLocalStorage = getLocalStorage;

var setLocalStorage = function setLocalStorage(a) {
  return localStorage.setItem(ASSETS_CACHE, JSON.stringify(a));
};

exports.setLocalStorage = setLocalStorage;